export const types = [
    "string",
    "default"
];

export function format(value) {
    return value;
}